/**
 * Amazon 写入失败的原始信息形如
 * `Amazon target bid write failed: 400 {"code":"X","message":"..."}`——
 * 前缀是我们的包装,真正可读的是 JSON 里的 code/message。提取出来展示,
 * 解析不动的原样返回。
 */
export function formatAmazonError(raw: string): string {
  const jsonStart = raw.indexOf("{");
  if (jsonStart >= 0) {
    try {
      const parsed = JSON.parse(raw.slice(jsonStart)) as {
        code?: unknown;
        message?: unknown;
      };
      const message = typeof parsed.message === "string" ? parsed.message : null;
      const code = typeof parsed.code === "string" ? parsed.code : null;
      if (message) return code ? `${code}: ${message}` : message;
    } catch {
      // fall through to raw
    }
  }
  return raw;
}
